import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import useWorkforceStore from '../store'
import { defer } from 'react-router-dom'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in Approvals loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in Approvals loader')

  const getStaffMembers = useWorkforceStore.getState().getStaffMembers()
  const getLeaveRequests = useWorkforceStore.getState().getLeaveRequests()
  const getLeaveTypes = useWorkforceStore.getState().getLeaveTypes()
  const getUnavailabilityRequests = useWorkforceStore
    .getState()
    .getUnavailability()

  const getStaffRoles = useWorkforceStore.getState().getStaffRoles(false)

  return defer({
    data: Promise.all([
      getStaffMembers,
      getLeaveRequests,
      getLeaveTypes,
      getUnavailabilityRequests,
      getStaffRoles,
    ])
      .then(() => true)
      .catch((error) => {
        logger.error('Approvals Promise.all error', error)
        return false
      }),
  })
}
